import { render } from "./bidInvite.vue?vue&type=template&id=2969157b&scoped=true"
import script from "./bidInvite.vue?vue&type=script&lang=js"
export * from "./bidInvite.vue?vue&type=script&lang=js"

import "./bidInvite.vue?vue&type=style&index=0&id=2969157b&lang=scss"
import "./bidInvite.vue?vue&type=style&index=1&id=2969157b&lang=scss&scoped=true"

import exportComponent from "/Users/a/Desktop/app/boyuan_pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2969157b"]])

export default __exports__